<template>
    <Navbar />
    <Header v-bind:title="title" />
  
    <section class="proj-section">
      <TabWrapper>
        <Tab title="Findings">
          <h2 class="proj-tab-title">Post Research Findings</h2>
  
          <div class="filter-div">
            <font-awesome-icon :icon="['fas', 'filter']" />
            Data year：
            <select class="select" v-model="allProjs.selectYear">
              <option :value="year" v-for="year in allProjs.yearArr" :key="year">{{ year+1911 }}</option>
            </select>
            
          </div>
          
          <table class="table table-hover rwd-table">
            <thead>
              <tr>
                <th class="th-title">ISSUE</th>
                <th>Administration</th>
              </tr>
            </thead>
  
            <tbody v-if="allProjs.data.length">
              <template v-for="item in filterSearch" :key="item.id">
                <tr v-if="item.year == allProjs.selectYear">
                  <td data-th="Issue" class="title" v-if="item.url">
                    <a v-bind:href="item.url" target="_blank">
                      {{ item.title_en }}
                    </a>
                  </td>
                  <td data-th="Issue" class="title" v-else>{{ item.title_en }}</td>
                  <td data-th="Administration" class="td-center">{{ item.depart_en }} </td>
                </tr>
              </template>
              
            </tbody>
          </table>
        </Tab>

      </TabWrapper>
    </section>
  
    <Footer />
  </template>
  
  <script>
  import Navbar from "@/components/Navbar.vue";
  import Header from "@/components/Header.vue";
  import TabWrapper from "@/components/TabWrapper.vue";
  import Tab from "@/components/Tab.vue";
  import Footer from "@/components/Footer.vue";
  import Loader from "@/components/Loader.vue";
  import Paginate from "@/components/Paginate.vue"
  
  import formatted from "@/mixin/formatted";
  
  export default {
    name: "App",
    components: { Navbar, Header,  Footer, Tab, TabWrapper, Loader, Paginate },
    mixins: [formatted],
  
    data() {
      return {
        title: "Findings",
        allProjs: {
          data: [],
          selectYear: "111",
          yearArr: [],
          searchWords: '',
        },

        paginate: {
          num: 1,
          size: 9
        }
      };
    },
  
    methods: {
      pageUpdate(num) {
        this.paginate.num = num;
      },
    },
  
    computed: {
      filterSearch() {
        return this.allProjs.data.filter(searchResult => searchResult.depart.match(this.allProjs.searchWords));
      }
    },
  
    mounted() {
      
      this.$i18n.locale = 'en';
  
      //fetch all project
      fetch("https://oir.nccu.edu.tw/codeigniter/api/resultlists")
        .then((respond) => respond.json())
        .then((data) => {
          this.allProjs.data = data;
          let tempYearArr = [];
  
          for (let index in data) {
            let year = data[index].year;
             tempYearArr.push(parseInt(year));
          }
  
          this.allProjs.yearArr =  tempYearArr.filter((item, index, arr) => {
              return arr.indexOf(item) === index;
          })
  
          this.allProjs.yearArr.sort(function(a, b) {
              return b - a;
          });
  
          this.allProjs.selectYear = this.allProjs.yearArr[0].toString();
  
        })
        
        .catch((err) => console.log(err.message));
    },
  };
  </script>
  
  <style src="@/assets/css/proj.css" scoped></style>
  <style src="@/assets/css/rwd-table.css" scoped></style>
  <style src="@/assets/css/table.css" scoped></style>
  